import React, { Component } from 'react';
import { Table, Alert, Button, Badge, Form, Row, Col, Card, Spinner, Modal } from 'react-bootstrap';
import paymentService from '../../../../services/PaymentService';

class PaymentHistory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            payments: [],
            pagination: {
                currentPage: 1,
                totalPages: 1,
                totalItems: 0,
                pageSize: 20
            },
            filters: {
                startDate: '',
                endDate: '',
                status: '',
                provider: '',
                cardNumber: '',
                beneficiaryName: ''
            },
            showDetailModal: false,
            selectedPayment: null,
            error: null
        };
    }

    componentDidMount() {
        this.loadPaymentHistory();
    }

    loadPaymentHistory = async (page = 1) => {
        this.setState({ loading: true, error: null });

        try {
            const { filters, pagination } = this.state;

            const params = {
                page: page,
                pageSize: pagination.pageSize,
                ...filters
            };

            const response = await paymentService.getPaymentHistory(params);

            this.setState({
                payments: response.data || [],
                pagination: {
                    ...pagination,
                    currentPage: page,
                    totalPages: response.totalPages || 1,
                    totalItems: response.totalItems || 0
                }
            });

        } catch (error) {
            console.error('Error loading payment history:', error);
            this.setState({ error: error.message || 'Erreur de chargement' });
        } finally {
            this.setState({ loading: false });
        }
    };

    handleFilterChange = (field, value) => {
        this.setState({
            filters: {
                ...this.state.filters,
                [field]: value
            }
        });
    };

    applyFilters = () => {
        this.loadPaymentHistory(1);
    };

    clearFilters = () => {
        this.setState({
            filters: {
                startDate: '',
                endDate: '',
                status: '',
                provider: '',
                cardNumber: '',
                beneficiaryName: ''
            }
        }, () => {
            this.loadPaymentHistory(1);
        });
    };

    showPaymentDetail = (payment) => {
        this.setState({
            selectedPayment: payment,
            showDetailModal: true
        });
    };

    getStatusBadge = (status) => {
        const variants = {
            'Pending': 'warning',
            'Completed': 'success',
            'Failed': 'danger',
            'Processing': 'info',
            'Cancelled': 'secondary'
        };

        const labels = {
            'Pending': 'En attente',
            'Completed': 'Terminé',
            'Failed': 'Échec',
            'Processing': 'En cours',
            'Cancelled': 'Annulé'
        };

        return (
            <Badge bg={variants[status] || 'secondary'}>
                {labels[status] || status}
            </Badge>
        );
    };

    getProviderIcon = (provider) => {
        const icons = {
            'OrangeMoney': 'fa-mobile-alt text-orange',
            'MtnMoney': 'fa-mobile-alt text-warning',
            'BankTransfer': 'fa-university text-primary'
        };

        return icons[provider] || 'fa-credit-card text-secondary';
    };

    renderFilters = () => {
        const { filters } = this.state;

        return (
            <Card className="mb-4">
                <Card.Header>
                    <h6 className="mb-0">
                        <i className="fa fa-filter me-2" />
                        Filtres de recherche
                    </h6>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Date début</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={filters.startDate}
                                    onChange={(e) => this.handleFilterChange('startDate', e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Date fin</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={filters.endDate}
                                    onChange={(e) => this.handleFilterChange('endDate', e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Statut</Form.Label>
                                <Form.Select
                                    value={filters.status}
                                    onChange={(e) => this.handleFilterChange('status', e.target.value)}
                                >
                                    <option value="">Tous les statuts</option>
                                    <option value="Completed">Terminé</option>
                                    <option value="Pending">En attente</option>
                                    <option value="Failed">Échec</option>
                                    <option value="Processing">En cours</option>
                                    <option value="Cancelled">Annulé</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Fournisseur</Form.Label>
                                <Form.Select
                                    value={filters.provider}
                                    onChange={(e) => this.handleFilterChange('provider', e.target.value)}
                                >
                                    <option value="">Tous les fournisseurs</option>
                                    <option value="OrangeMoney">Orange Money</option>
                                    <option value="MtnMoney">MTN Money</option>
                                    <option value="BankTransfer">Virement Bancaire</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Numéro de carte</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Rechercher par numéro de carte"
                                    value={filters.cardNumber}
                                    onChange={(e) => this.handleFilterChange('cardNumber', e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Nom du bénéficiaire</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Rechercher par nom"
                                    value={filters.beneficiaryName}
                                    onChange={(e) => this.handleFilterChange('beneficiaryName', e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="d-flex gap-2">
                        <Button variant="primary" onClick={this.applyFilters}>
                            <i className="fa fa-search me-2" />
                            Appliquer les filtres
                        </Button>
                        <Button variant="outline-secondary" onClick={this.clearFilters}>
                            <i className="fa fa-times me-2" />
                            Effacer
                        </Button>
                    </div>
                </Card.Body>
            </Card>
        );
    };

    renderPaymentTable = () => {
        const { payments, loading } = this.state;

        if (loading) {
            return (
                <div className="text-center py-5">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Chargement...</span>
                    </Spinner>
                </div>
            );
        }

        if (payments.length === 0) {
            return (
                <div className="text-center py-5">
                    <i className="fa fa-receipt fa-3x text-muted mb-3"></i>
                    <h6 className="text-muted">Aucun paiement trouvé</h6>
                    <p className="text-muted">Aucun paiement ne correspond aux critères de recherche.</p>
                </div>
            );
        }

        return (
            <div className="table-responsive">
                <Table hover>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Transaction ID</th>
                            <th>Carte</th>
                            <th>Bénéficiaire</th>
                            <th>Montant</th>
                            <th>Fournisseur</th>
                            <th>Statut</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {payments.map((payment, index) => (
                            <tr key={payment.id || index}>
                                <td>
                                    <div>{new Date(payment.paymentDate).toLocaleDateString('fr-FR')}</div>
                                    <small className="text-muted">
                                        {new Date(payment.paymentDate).toLocaleTimeString('fr-FR', {
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}
                                    </small>
                                </td>
                                <td>
                                    <code>{payment.transactionId}</code>
                                </td>
                                <td>
                                    <div className="fw-medium">{payment.cardNumber}</div>
                                    <small className="text-muted">ID: {payment.cardId}</small>
                                </td>
                                <td>{payment.beneficiaryName}</td>
                                <td>
                                    <strong>{payment.amount.toLocaleString()} {payment.currency}</strong>
                                </td>
                                <td>
                                    <div className="d-flex align-items-center">
                                        <i className={`fa ${this.getProviderIcon(payment.provider)} me-2`}></i>
                                        {payment.provider}
                                    </div>
                                </td>
                                <td>{this.getStatusBadge(payment.status)}</td>
                                <td>
                                    <Button
                                        variant="outline-info"
                                        size="sm"
                                        onClick={() => this.showPaymentDetail(payment)}
                                        title="Voir détails"
                                    >
                                        <i className="fa fa-eye"></i>
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        );
    };

    renderPagination = () => {
        const { pagination } = this.state;

        if (pagination.totalPages <= 1) return null;

        const pages = [];
        for (let i = 1; i <= pagination.totalPages; i++) {
            pages.push(
                <Button
                    key={i}
                    variant={i === pagination.currentPage ? 'primary' : 'outline-primary'}
                    size="sm"
                    onClick={() => this.loadPaymentHistory(i)}
                    className="me-1"
                >
                    {i}
                </Button>
            );
        }

        return (
            <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="text-muted">
                    Affichage de {((pagination.currentPage - 1) * pagination.pageSize) + 1} à{' '}
                    {Math.min(pagination.currentPage * pagination.pageSize, pagination.totalItems)} sur{' '}
                    {pagination.totalItems} paiements
                </div>
                <div>{pages}</div>
            </div>
        );
    };

    renderDetailModal = () => {
        const { showDetailModal, selectedPayment } = this.state;

        if (!selectedPayment) return null;

        return (
            <Modal
                show={showDetailModal}
                onHide={() => this.setState({ showDetailModal: false })}
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="fa fa-receipt me-2" />
                        Détails du paiement
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={6}>
                            <Card>
                                <Card.Header>
                                    <h6 className="mb-0">Informations générales</h6>
                                </Card.Header>
                                <Card.Body>
                                    <p><strong>Transaction ID:</strong> <code>{selectedPayment.transactionId}</code></p>
                                    <p><strong>Date:</strong> {new Date(selectedPayment.paymentDate).toLocaleDateString('fr-FR')}</p>
                                    <p><strong>Statut:</strong> {this.getStatusBadge(selectedPayment.status)}</p>
                                    <p><strong>Montant:</strong> <span className="h6">{selectedPayment.amount.toLocaleString()} {selectedPayment.currency}</span></p>
                                    <p><strong>Fournisseur:</strong> {selectedPayment.provider}</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card>
                                <Card.Header>
                                    <h6 className="mb-0">Informations carte</h6>
                                </Card.Header>
                                <Card.Body>
                                    <p><strong>Numéro carte:</strong> {selectedPayment.cardNumber}</p>
                                    <p><strong>ID carte:</strong> {selectedPayment.cardId}</p>
                                    <p><strong>Bénéficiaire:</strong> {selectedPayment.beneficiaryName}</p>
                                    {selectedPayment.phoneNumber && (
                                        <p><strong>Téléphone:</strong> {selectedPayment.phoneNumber}</p>
                                    )}
                                    {selectedPayment.email && (
                                        <p><strong>Email:</strong> {selectedPayment.email}</p>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {selectedPayment.failureReason && (
                        <Alert variant="danger" className="mt-3">
                            <Alert.Heading>Raison de l'échec</Alert.Heading>
                            {selectedPayment.failureReason}
                        </Alert>
                    )}

                    {selectedPayment.notes && (
                        <Alert variant="info" className="mt-3">
                            <Alert.Heading>Notes</Alert.Heading>
                            {selectedPayment.notes}
                        </Alert>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.setState({ showDetailModal: false })}>
                        Fermer
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    render() {
        const { error, pagination } = this.state;

        return (
            <div>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                        <h5 className="mb-1">
                            <i className="fa fa-history me-2" />
                            Historique des paiements
                        </h5>
                        <p className="text-muted mb-0">
                            {pagination.totalItems > 0 && `${pagination.totalItems.toLocaleString()} paiement(s) au total`}
                        </p>
                    </div>
                </div>

                {error && (
                    <Alert variant="danger" className="mb-4">
                        <i className="fa fa-exclamation-triangle me-2" />
                        {error}
                    </Alert>
                )}

                {this.renderFilters()}

                <Card>
                    <Card.Body className="p-0">
                        {this.renderPaymentTable()}
                    </Card.Body>
                    {pagination.totalPages > 1 && (
                        <Card.Footer className="bg-light">
                            {this.renderPagination()}
                        </Card.Footer>
                    )}
                </Card>

                {this.renderDetailModal()}
            </div>
        );
    }
}

export default PaymentHistory;